type FormattedName = {
  displayName: string
  initials: string
}

/**
 * Formats a name into various formats including initials
 * @param name - The full name to format
 * @returns Object containing firstName, displayName (with last initial), and initials
 *
 * A companion whose name carries no surname keeps their single name and gets a single initial.
 * `lastName` is `undefined` for a one-token name, and reading `.charAt(0)` off it threw a TypeError
 * for every caller until CONAPP-294 — the same input `@internal/telemedicine`'s
 * `formatProviderInitials` already absorbs.
 *
 * Splits on ONE-OR-MORE whitespace, not on a single space: the stored name is admin-entered, so a
 * double space or a tab between the two names is reachable, and `split(" ")` reads the empty token
 * between them as the surname — which silently degrades "Avery  Parker" to "Avery" / "A" rather
 * than failing. Tabs never split at all under the old form and rode into `displayName` verbatim.
 */
export const formatCarrotCompanionName = (name?: string): FormattedName => {
  if (!name) {
    return {
      displayName: "",
      initials: ""
    }
  }

  const [firstName, lastName] = name.trim().split(/\s+/)
  const lastInitial = lastName ? lastName.charAt(0).toUpperCase() : ""
  const firstInitial = firstName.charAt(0).toUpperCase()

  return {
    displayName: lastInitial ? `${firstName} ${lastInitial}.` : firstName,
    initials: `${firstInitial}${lastInitial}`
  }
}
